import {FC, useContext} from "react";
import {Box, BoxProps} from "@mui/material";
import {useApi} from "@buildwitt/shapeshift-identity";
import {makeStyles} from "tss-react/mui";
import {IAdminUsersQuizzesResponseEntry, ILocalizationEntity} from "@buildwitt/shapeshift-types";
import {AdminTable, AdminTableProps} from "@/components/common/table";
import {GRID_CHECKBOX_SELECTION_COL_DEF} from "@mui/x-data-grid-pro";
import {PageBaseContext} from "@/contexts/pageBaseContext";

const useStyles = makeStyles()((theme) => ({
	adminLessonInlineQuiz: {},
	quizCard: {
		background: theme.palette.grey[100],
		width: "fit-content",
		display: "flex",
		justifyContent: "space-between",
		"& svg path": {
			fill: theme.palette.primary.main,
			cursor: "pointer"
		},
		"& > *": {
			padding: "20px"
		}
	},
	quizTitle: {
		cursor: "pointer"
	},
	searchResults: {
		marginTop: "20px",
		"& tr: hover": {
			cursor: "pointer",
			background: theme.palette.grey[200]
		}
	}
})
);


const headCells = (locales?: ILocalizationEntity[], ownedCohortTitle?: string): AdminTableProps<"quiz", IAdminUsersQuizzesResponseEntry>["columns"] => ([
	{
		...GRID_CHECKBOX_SELECTION_COL_DEF,
		type: "string",
		hideable: false
	},
	{
		field: "title",
		type: "string",
		flex: 1,
		headerName: "Title",
		minWidth: 240
	},
	{
		field: "languages",
		type: "string",
		filterable: false,
		flex: 1,
		headerName: "Supported Languages",
		valueGetter: ({value}: {value: IAdminUsersQuizzesResponseEntry["languages"]}) => value?.map(e => locales?.find(x => x.code === e)?.name)?.join(", ")
	}
]);

interface IProps extends Omit<BoxProps, "onChange"> {
	quizId?: number | null,
	onChange: (quizId: number) => void
}

export const AttachQuizInline: FC<IProps> = ({quizId, onChange, className, ...props}) => {
	const {cx, classes} = useStyles();
	const [locales] = useApi<ILocalizationEntity[]>("/api/settings/i18n");
	const [{ownedCohort}] = useContext(PageBaseContext)

	return (
		<Box className={cx(classes.adminLessonInlineQuiz, className)} {...props}>
			<Box className={classes.searchResults}>
				<AdminTable<"quiz", IAdminUsersQuizzesResponseEntry>
					url="/api/strapi-plugin-shapeshift-lms/cohort/quiz"
					columns={headCells(locales.data, typeof ownedCohort === "object" ? ownedCohort?.title : undefined)}
					onSelectionModelChange={e => {
						onChange((e?.pop?.() as number) ?? null);
					}}
					selectionModel={quizId ? [quizId] : []}
					type="quiz"
					disableExport
				/>
			</Box>
		</Box>
	);
}